import { History } from 'lucide-react';

const fmtDay = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('en-ZA', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'Africa/Johannesburg' }); } catch { return iso.slice(0, 10); }
};
const fmtWhen = (iso) => {
  try { return new Date(iso).toLocaleString('en-ZA', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Africa/Johannesburg' }); } catch { return iso; }
};

export const WindowHistoryList = ({ history }) => {
  const rows = [...(history || [])].reverse().slice(0, 10);
  return (
    <div className="rounded-xl border border-border p-3" data-testid="window-history">
      <p className="font-body text-xs font-medium text-foreground/70 mb-2 inline-flex items-center gap-1.5">
        <History className="h-3.5 w-3.5" /> Window history
      </p>
      {rows.length === 0 ? (
        <p className="font-body text-xs text-foreground/60" data-testid="window-history-empty">No changes recorded yet.</p>
      ) : (
        <ul className="space-y-1.5 max-h-40 overflow-y-auto">
          {rows.map((h, i) => (
            <li key={`${h.at}-${i}`} className="font-body text-xs text-foreground/85" data-testid={`window-history-row-${i}`}>
              <span className="text-foreground/60">{fmtWhen(h.at)} · {h.actor}{h.source === 'import' ? ' (import)' : ''}</span>
              <br />
              {fmtDay(h.old_open)} – {fmtDay(h.old_close)} <span className="text-gold">→</span> {fmtDay(h.new_open)} – {fmtDay(h.new_close)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
